import loadable from '@loadable/component';

export const SendOfferScreen =  loadable(() => import('./index'));
